module.exports = __webpack_public_path__ + "static/img/img02.d1dcc5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advance/img02.png
// module id = /xUh
// module chunks = 1